// extracted by mini-css-extract-plugin
export default {"wrapper":"Paper_wrapper__qX7jG"};